import request from '../../src/state/modules/axios'

export function getUsers(params) {
    return request({
        url: '/api/users',
        method: 'get',
        params,
    })
}

export function storeUser(data) {
    return request({
        url: '/api/users',
        method:'post',
        data,
    })
}

export function getUser(id) {
    return request({
        url: `/api/users/${id}`,
        method:'get',
    });
}

export function updateUser(data) {
    return request({
        url: `/api/users/${data.id}`,
        method: 'put',
        data,
    });
}

export function getRoles(params) {
    return request({
        url: '/api/roles',
        method:'get',
        params,
    })
}
